/** A route's `handle` that leaves out the site's header, footer and dock: a page that belongs to another app's flow. */
export const STANDALONE = { chrome: "none" } as const
